import { Soon } from "@/components/Soon";
import { ExternalLinkRow, Group, SettingRow } from "./parts";

/** Who can reach you, what your profile shows, and Pax's policies. */
export function PrivacySection() {
  return (
    <div className="flex flex-col gap-6">
      <Group>
        <SettingRow title="Friend requests from" muted>
          <Soon />
        </SettingRow>
      </Group>
      <Group label="Show on profile">
        <SettingRow title="Last active" muted>
          <Soon />
        </SettingRow>
        <SettingRow title="Play stats" muted>
          <Soon />
        </SettingRow>
      </Group>
      <Group>
        <SettingRow title="Blocked users" muted>
          <Soon />
        </SettingRow>
      </Group>
      <Group>
        <ExternalLinkRow label="Privacy policy" href="/privacy" />
        <ExternalLinkRow label="Terms of service" href="/terms" />
      </Group>
    </div>
  );
}
